import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useGetBasketSizeLimitConfiguration() {
  return useCbhFlag(CbhFeatureFlag.BASKET_SIZE_LIMIT_CONFIGURATION, {
    defaultValue: {
      limited: { enabled: false },
      warning: { enabled: false },
    },
  });
}
